import { configureStore } from '@reduxjs/toolkit';
import { participantsReducer } from './Participants/reducer';

const store = configureStore({
    reducer: {
        participants: participantsReducer
    }
});

export default store;